import { render, staticRenderFns } from "./EggGame.vue?vue&type=template&id=d06fd268&scoped=true&"
import script from "./EggGame.vue?vue&type=script&lang=js&"
export * from "./EggGame.vue?vue&type=script&lang=js&"
import style0 from "./EggGame.vue?vue&type=style&index=0&id=d06fd268&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d06fd268",
  null
  
)

export default component.exports